import {BigCalendarEvent} from '../types/BigCalendarEvent';
import {calculateEventLayout} from './calculateEventLayout';
import {isAllDayHeaderEvent} from './isAllDayHeaderEvent';
import {isDateInEventRange} from './isDateInEventRange';

/**
 * Splits the events touching a date into the two places the week and day views draw them:
 * the timeline for single-day timed events, and the all-day header for everything else. Multi-day
 * events keep their original boundaries so the header can draw them as one bar across days.
 */
export function getEventsForDate(events: BigCalendarEvent[], date: Date) {
  const eventsInRange = events.filter((event) => isDateInEventRange(event.start, event.end, date));

  const allDayEvents = eventsInRange.filter(isAllDayHeaderEvent);
  const regularEvents = eventsInRange
    .filter((event) => !isAllDayHeaderEvent(event))
    .map((event) => ({...event, isActualEventEnd: true}));

  return {
    regularEvents: calculateEventLayout(regularEvents),
    allDayEvents,
  };
}
